import {
  AUTH_STORAGE_KEY,
  isAuthRecordExpired,
  type AuthRecord,
} from "./AuthTypes";

const CHANGE_EVENT = "sugar-auth-change";

function read(): AuthRecord | null {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthRecord;
    if (!parsed?.ticket || isAuthRecordExpired(parsed)) {
      if (parsed?.ticket) localStorage.removeItem(AUTH_STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function write(record: AuthRecord | null) {
  if (!record?.ticket) {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } else {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(record));
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}

export const AuthSession = {
  get(): AuthRecord | null {
    return read();
  },

  set(record: AuthRecord) {
    write(record);
  },

  clear() {
    write(null);
  },

  subscribe(listener: () => void): () => void {
    const onCustom = () => listener();
    const onStorage = (event: StorageEvent) => {
      if (event.key === AUTH_STORAGE_KEY || event.key === null) listener();
    };
    window.addEventListener(CHANGE_EVENT, onCustom);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(CHANGE_EVENT, onCustom);
      window.removeEventListener("storage", onStorage);
    };
  },
};
